export enum TaskStatus {
  STARTED = 'started',
  FAILURE = 'failure',
  SUCCESS = 'success',
}
